/** Public support and privacy contact; must be a monitored kaizen.co.ke mailbox. */
export const SUPPORT_EMAIL = "support@kaizen.co.ke";
